import React, { ReactElement } from 'react';
import { HeadTag } from 'shared/components';
import { Box } from '@mui/material';
import PageHeader from 'shared/components/PageHeader';
import IncidentsCard from './components/IncidentsCard';

const Incidents = (): ReactElement => (
  <>
    <PageHeader
      title="Incident Log"
      description="Track, manage, and resolve AI and data incidents"
    />
    <Box className="incident-management incidents">
      <HeadTag title="Incidents log" />

      <Box className="incidents-wrapper">
        <IncidentsCard />
      </Box>
    </Box>
  </>
);

export default Incidents;
